import * as Redux from 'redux';
import {
  REGISTER_POS,
  GET_POS_HISTORIES,
  REFUND_POS,
  EMAIL_RECEIPT,
  CREATE_PREDEFINED_ITEM,
  UPDATE_PREDEFINED_ITEM,
  DELETE_PREDEFINED_ITEM,
  GET_PREDEFINED_ITEMS
} from './Constants';
import {
  PosActionTypes,
  PosRegisterRequest,
  GetPosHistoriesRequest,
  RefundPosRequest
} from './Types';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { pickAuthOrImpersonationToken } from '../util/token.util';

export const registerPos: Redux.ActionCreator<
  ReduxPromiseAction<
    PosActionTypes, SimpleResponse<{}>
  >
> = (posRegisterRequest: PosRegisterRequest): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
  type: REGISTER_POS,
  payload: callApi(
    process.env.REACT_APP_API + '/pos/sale',
    true,
    {
      method: 'POST',
      headers: {
        'Authorization': pickAuthOrImpersonationToken(),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        cardNumber: posRegisterRequest.cardNumber,
        cardHolderName: posRegisterRequest.cardHolderName,
        cvc: posRegisterRequest.cvc,
        amount: posRegisterRequest.amount,
        expiryMonth: posRegisterRequest.expiryMonth,
        expiryYear: posRegisterRequest.expiryYear,
        description: posRegisterRequest.description,
        currency: posRegisterRequest.currency,
        email: posRegisterRequest.email,
        tax: posRegisterRequest.tax,
        total: posRegisterRequest.total,
        associatedMemberId: posRegisterRequest.id,
        paymentMethodType: posRegisterRequest.paymentMethodType,
        payMethodId: posRegisterRequest.payMethodId
      })
    }
  )
});

export const getPosHistories: Redux.ActionCreator<
  ReduxPromiseAction<
    PosActionTypes, SimpleResponse<{}>
  >
> = (req: GetPosHistoriesRequest): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
  type: GET_POS_HISTORIES,
  payload: callApi(
    process.env.REACT_APP_API + '/pos/history/' + req.year + '/' + req.month,
    true,
    {
      method: 'GET',
      headers: {
        'Authorization': pickAuthOrImpersonationToken(),
        'Content-Type': 'application/json'
      }
    }
  )
});

export const refund: Redux.ActionCreator<ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>>> =
  (req: RefundPosRequest): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
    type: REFUND_POS,
    payload: callApi(
      process.env.REACT_APP_API + '/pos/creditcard/refund',
      true,
      {
        method: 'POST',
        headers: {
          'Authorization': pickAuthOrImpersonationToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          receiptId: req.receiptId
        })
      }
    )
  });

export const emailReceipt: Redux.ActionCreator<ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>>> =
  (entityId: number): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
    type: EMAIL_RECEIPT,
    payload: callApi(
      process.env.REACT_APP_API + '/pos/email/' + entityId,
      true,
      {
        method: 'GET',
        headers: {
          'Authorization': pickAuthOrImpersonationToken(),
          'Content-Type': 'application/json'
        }
      }
    )
  });

export const createPredefinedItem: Redux.ActionCreator<ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>>> =
  (req: PosRegisterRequest): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
    type: CREATE_PREDEFINED_ITEM,
    payload: callApi(
      process.env.REACT_APP_API + '/pos/predefineditem',
      true,
      {
        method: 'POST',
        headers: {
          'Authorization': pickAuthOrImpersonationToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: req.predefinedItemName,
          amount: req.amount,
          tax: req.tax,
          total: req.total,
          currency: req.currency,
          description: req.description
        })
      }
    )
  });

export const updatePredefinedItem: Redux.ActionCreator<ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>>> =
  (req: PosRegisterRequest): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
    type: UPDATE_PREDEFINED_ITEM,
    payload: callApi(
      process.env.REACT_APP_API + '/pos/predefineditem',
      true,
      {
        method: 'PATCH',
        headers: {
          'Authorization': pickAuthOrImpersonationToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: req.id,
          name: req.predefinedItemName,
          amount: req.amount,
          tax: req.tax,
          total: req.total,
          currency: req.currency,
          description: req.description
        })
      }
    )
  });

export const deletePredefinedItem: Redux.ActionCreator<ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>>> =
  (id: number): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
    type: DELETE_PREDEFINED_ITEM,
    payload: callApi(
      process.env.REACT_APP_API + '/pos/predefineditem/' + id,
      true,
      {
        method: 'DELETE',
        headers: {
          'Authorization': pickAuthOrImpersonationToken(),
          'Content-Type': 'application/json'
        }
      }
    )
  });

export const getPredefinedItems: Redux.ActionCreator<ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>>> =
  (): ReduxPromiseAction<PosActionTypes, SimpleResponse<{}>> => ({
    type: GET_PREDEFINED_ITEMS,
    payload: callApi(
      process.env.REACT_APP_API + '/pos/predefineditem/list',
      true,
      {
        method: 'GET',
        headers: {
          'Authorization': pickAuthOrImpersonationToken(),
          'Content-Type': 'application/json'
        }
      }
    )
  });



// WEBPACK FOOTER //
// ./src/pos/Actions.tsx